const ActiveHeaderType = {
    SET_ACTIVE_HEADER:'SET_ACTIVE_HEADER'
}
export default ActiveHeaderType;